"use client";

import { ComponentType, createContext, useContext } from "react";

export default function withLoadingProps<Props extends Record<string, unknown>>(
  loader: (useLoadingProps: () => Props) => ComponentType<Props>,
): ComponentType<Props> {
  const LoadingPropsContext = createContext({} as Props);

  const useLoadingProps = () => useContext(LoadingPropsContext);

  const Dynamic = loader(useLoadingProps);

  function WithLoadingProps(props: Props) {
    return (
      <LoadingPropsContext.Provider value={props}>
        <Dynamic {...props} />
      </LoadingPropsContext.Provider>
    );
  }

  return WithLoadingProps;
}
